import script from "./ProjectsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectsView.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectsView.vue?vue&type=style&index=0&id=ef1832b6&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef1832b6"]])

export default __exports__